export default "__VITE_ASSET__DyXToAen__"